export const datalakeToken = `
eyJ4NXQiOiJNV1V4WW1Oa1pXSXdZVFEyTkRjeU1UVXdZelUxTlRReVlUbGpZekF5WmpNNU5EZ3ha
VFZrWkRGbE5tVmhORGt6WXpneVlqQXlNMk5pWlRBellqUTBZdyIsImtpZCI6Ik1XVXhZbU5rWldJ
d1lUUTJORGN5TVRVd1l6VTFOVFF5WVRsall6QXlaak01TkRneFpUVmtaREZsTm1WaE5Ea3pZemd5
WWpBeU0yTmlaVEF6WWpRMFl3X1JTMjU2IiwidHlwIjoiYXQrand0IiwiYWxnIjoiUlMyNTYifQ.e
yJzdWIiOiI5ZTgzNDhmOS0zMDQ0LTQ5NDgtYTljNi1jNThlM2IxNDkzMzYiLCJhdXQiOiJBUFBMS
UNBVElPTiIsImJpbmRpbmdfdHlwZSI6InJlcXVlc3QiLCJpc3MiOiJodHRwczovL21hbmFnZXIub
WdhcGkucHJvZGVtZ2UuZ292LmJyL29hdXRoMi90b2tlbiIsImNsaWVudF9pZCI6ImszMjFTTDhHZ
DhBaVJuUXdobF92aVVYTnRKd2EiLCJhdWQiOiJrMzIxU0w4R2Q4QWlSblF3aGxfdmlVWE50SndhI
iwibmJmIjoxNzU3Njg1Nzk5LCJhenAiOiJrMzIxU0w4R2Q4QWlSblF3aGxfdmlVWE50SndhIiwic
2NvcGUiOiJkZWZhdWx0IiwiZXhwIjo4ODE1ODY4NTc5OCwiaWF0IjoxNzU3Njg1Nzk5LCJiaW5ka
W5nX3JlZiI6ImIxOTFlNGU2ZTk3MDljOWMwMTQ4NjViY2IxYzBlMzI4IiwianRpIjoiYTcwNDljN
zktODM4OC00ZWY1LTlkODEtMjIyOWFmYzFmNjFmIn0.BhLQ74YigDTxTTlZRZtwct5TO5lMYKOLa
h897V7NhMDtvDGxazeNpNJZGIz6g9Fmixye7jgba-WS7iFbdSwdLsxJuQoSneOsPgdsscoCl6HUB
AVCgxyIiIg3BqMj9ZVDBH08xWPOPImaHhXunXKrlawXQayrXCXI45R-cIauDtwITW3am1gfvm-Ob
PWkam6JftNmRIklOMH6KljkLAY4lKW2oZKwAglGMYJ6v-u7IhwycuirYfmIKcbWR7VY4W0e2lNgE
53KyA9-g4l9Rqm3H8Tqxf2_xqhKXU-8xlLgCJAAOazloIcv5ntTdXszyzqmA62gDn76Qa0iRienFjnSjw
`.replace(/\n/g, '');